import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { addEquipmentFormSchema } from './add-equipment-form.schema'

export const useAddEquipmentForm = () => {
  const form = useForm({
    resolver: yupResolver(addEquipmentFormSchema),
    defaultValues: addEquipmentFormSchema.cast({}),
  })

  return { form }
}
